var _mask, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 8,
    width: 18,
    height: 15
  }, /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 18,
    height: 15,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0688 8L5.36036 8.02196C5.34862 8 5.04173 7.66766 5.0288 7.64585L4.21423 6.27846C2.99442 4.23038 3.58596 1.52097 5.53382 0.236876C6.47715 -0.384227 7.59511 -0.584268 8.6804 -0.320799C9.76521 -0.0598401 10.6885 0.631172 11.2793 1.62211L11.2809 1.62371L12.7328 4.0594C12.9641 4.44714 13.3611 4.66022 13.7667 4.66022C13.9885 4.66022 14.213 4.59721 14.4137 4.46429C14.9846 4.08839 15.157 3.2968 14.7999 2.6964L13.3475 0.260713C13.346 0.259041 13.3452 0.257368 13.3435 0.255277C12.4063 -1.31382 10.9444 -2.40708 9.22539 -2.82201C7.50488 -3.23596 5.73404 -2.92266 4.23763 -1.9366C1.14999 0.0970562 0.211766 4.39354 2.14669 7.63978L2.47774 8H1.21967C0.545459 8 0 8.29205 0 9V21.7179C0 22.4261 0.545459 23 1.21967 23H16.7801C17.4529 23 18 22.4262 18 21.7179V8.99442C18.0009 8.28605 17.7416 8 17.0688 8Z",
    fill: "current"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 8.625H15V5.75C15 2.5788 12.3091 0 9 0C5.69092 0 3 2.5788 3 5.75V8.625H2.25C1.01001 8.625 0 9.59187 0 10.7812V20.8437C0 22.0331 1.01001 23 2.25 23H15.75C16.99 23 18 22.0331 18 20.8437V10.7812C18 9.59187 16.99 8.625 15.75 8.625ZM5.00006 5.75C5.00006 3.63586 6.79395 1.91673 9 1.91673C11.2061 1.91673 12.9999 3.63586 12.9999 5.75V8.625H5.00006V5.75Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.84bdae4e587e90bf163c23be98416d20.svg";
export { ForwardRef as ReactComponent };